import React, { Component } from 'react';
import styles from './styles.module.css';

import glassData from '../../../../../data/glassData.js';
import TEXT from '../../../../../data/text.json';
import searchFilterAndSortGlass from '../../../../utils/search/glass';

import PillButton from '../../../pill-button';
import Square from '../../../square';
import PlusIcon from '../../../../icons/Plus';
import CrossIcon from '../../../../icons/Cross';

import TextBox from '../text-box';

const SelectedItem = ({ id, onClick, noRemove }) => (
  <button
    className={styles.selectedItem}
    onClick={event => {
      event.preventDefault();
      onClick();
    }}
  >
    <span>{glassData.find(item => item.id === id).title}</span>
    {!noRemove && <CrossIcon color="white" />}
  </button>
);

const ResultItem = ({ title, onClick }) => (
  <button
    className={styles.resultItem}
    onClick={event => {
      event.preventDefault();
      onClick();
    }}
  >
    <span>{title}</span>
    <PlusIcon size={12} color="white" />
  </button>
);

const searchGlass = (items, searchTerm, alreadySelected) =>
  searchFilterAndSortGlass(items, searchTerm)
    .filter(item => !alreadySelected.includes(item.id))
    .slice(0, 8);

export default class RelatedItemSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: '',
      searchResults: searchGlass(glassData, '', [props.preselectedItemId])
    };
  }

  setSearchTerm = event =>
    this.setState({
      searchTerm: event.target.value,
      searchResults: searchGlass(
        glassData,
        event.target.value,
        this.props.selectedItems
      )
    });

  selectItem = id => {
    const newSelectedItems = [...this.props.selectedItems, id];
    this.props.onChange(newSelectedItems);
    this.setState(state => ({
      searchResults: searchGlass(glassData, state.searchTerm, newSelectedItems)
    }));
  };

  deselectItem = id => {
    const newSelectedItems = this.props.selectedItems.filter(
      value => value !== id
    );
    this.props.onChange(newSelectedItems);
    this.setState(state => ({
      searchResults: searchGlass(glassData, state.searchTerm, newSelectedItems)
    }));
  };

  render() {
    return (
      <div className={styles.container}>
        <div>
          {this.props.form === 'memory'
            ? TEXT.FORMS.releatedItemsMemoryDescription
            : TEXT.FORMS.releatedItemsItemDescription}
        </div>

        {this.props.selectedItems.length === 0 ? (
          <div className={styles.noneSelected}>
            No items selected. Search for some below.
          </div>
        ) : (
          <div>
            <ul className={styles.selected}>
              {this.props.selectedItems.map(id => (
                <li key={id}>
                  <SelectedItem
                    id={id}
                    onClick={() => this.deselectItem(id)}
                    noRemove={id === this.props.preselectedItemId}
                  />
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className={styles.searchAndSelect}>
          <TextBox
            id="itemSearch"
            label="Search items"
            placeholder="Search for items by name..."
            value={this.state.searchTerm}
            onChange={this.setSearchTerm}
          />

          {this.state.searchResults.length === 0 || !this.state.searchTerm ? (
            <div className={styles.noResults}>
              {!this.state.searchTerm
                ? 'Enter a search term to see items to select.'
                : 'No items found matching that search term.'}
            </div>
          ) : (
            <ul className={styles.results}>
              {this.state.searchResults.map(({ id, title }) => (
                <li key={id}>
                  <ResultItem
                    title={title}
                    onClick={() => this.selectItem(id)}
                  />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/related-items-selection/index.js